<template>
  <div v-if="hasData" class="rs" data-test="release-split">
    <span class="rs-label">Delivered breakdown</span>
    <div class="rs-bar" role="img" :aria-label="ariaLabel">
      <span class="rs-released" :style="{ width: releasedPctWidth }" />
      <span class="rs-pending" :style="{ width: pendingPctWidth }" />
    </div>
    <div class="rs-legend">
      <span class="rs-legend-item">
        <span class="dot dot-released" />Released <strong>{{ released.released_sp }} SP</strong>
      </span>
      <span class="rs-legend-item">
        <span class="dot dot-pending" />Awaiting release <strong>{{ released.merged_pending_release_sp }} SP</strong>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { ReleaseSplit } from "@/api/types";

const props = defineProps<{ release?: ReleaseSplit }>();

const released = computed(() => props.release ?? { released_sp: 0, merged_pending_release_sp: 0, delivered_sp: 0 });
const hasData = computed(() => released.value.delivered_sp > 0);

const releasedPctWidth = computed(() => {
  const total = released.value.delivered_sp || 1;
  return `${(released.value.released_sp / total) * 100}%`;
});
const pendingPctWidth = computed(() => {
  const total = released.value.delivered_sp || 1;
  return `${(released.value.merged_pending_release_sp / total) * 100}%`;
});
const ariaLabel = computed(
  () =>
    `${released.value.released_sp} SP released, ${released.value.merged_pending_release_sp} SP awaiting release`,
);
</script>

<style scoped>
.rs {
  background: var(--surface-card, #fff);
  border: 1px solid var(--surface-border, #e5e7eb);
  border-radius: 8px;
  padding: 10px 14px;
  display: flex; flex-direction: column; gap: 6px;
}
.rs-label { font-size: 11px; color: var(--text-muted, #6b7280); text-transform: uppercase; letter-spacing: 0.04em; }
.rs-bar {
  display: flex; height: 12px; border-radius: 999px; overflow: hidden;
  background: var(--surface-elev, #f3f4f6);
}
.rs-released { background: #15803d; }
.rs-pending { background: #2563eb; }
.rs-legend { display: flex; gap: 16px; font-size: 12px; color: var(--text-color, #111827); }
.rs-legend-item { display: inline-flex; align-items: center; gap: 6px; }
.dot { width: 8px; height: 8px; border-radius: 50%; }
.dot-released { background: #15803d; }
.dot-pending { background: #2563eb; }
.rs-legend strong { font-weight: 600; }
</style>
